import { createContext, useContext } from "react";
import {
  ComponentTemplatePrivacyType,
  ComponentTemplateSort,
  ComponentType,
} from "@growth-machine-llc/stridist-api-client";
import { AllOptionType } from "./ProgramLibraryFilterContext";

export interface TemplateListFilterContextValues {
  query: string;
  sortKey: ComponentTemplateSort;
  templatePrivacyType: ComponentTemplatePrivacyType;
  templateType: ComponentType[] | AllOptionType;
  handleSortKeyChange: (sortKey: ComponentTemplateSort) => void;
  handleQueryChange: (query: string) => void;
  handleTemplatePrivacyTypeChange: (
    templatePrivacyType: ComponentTemplatePrivacyType,
  ) => void;
  handleComponentTemplateTypeChange: (
    type: ComponentType[] | AllOptionType,
  ) => void;
}

export const TemplateListFilterContext = createContext<
  TemplateListFilterContextValues | undefined
>(undefined);

export const useTemplateListFilterContext = () => {
  const context = useContext(TemplateListFilterContext);
  if (context === undefined) {
    throw new Error(
      "TemplateListFilterContext must be used within a TemplateListFilterProvider",
    );
  }
  return context;
};
